import { BoxxOAuthResponseProps } from './IBoxxOAuth';

export interface IGMBOAuthResponse extends BoxxOAuthResponseProps {
  authResponse: {
    accessToken: string;
    userID: string;
    code?: string;
  };
  profileResponse: {
    email: string;
    firstName: string;
    lastName: string;
    imageUrl?: string;
  };
}

export interface IGmbAccountApiPayload {
  accounts: IGmbAccount[];
}

export interface IGmbAccount {
  name: string;
  accountName: string;
  type: string;
  state: {
    status: string;
    vettedStatus: string;
  };
  profilePhotoUrl: string;
}

export interface IGmbAccountLocationsApiPayload {
  locations: GmbLocation[];
}

export interface GmbServiceType {
  serviceTypeId: string;
  displayName: string;
}

export interface GmbMoreHoursType {
  hoursTypeId: string;
  displayName: string;
  localizedDisplayName: string;
}

export interface GmbPrimaryCategory {
  displayName: string;
  categoryId: string;
  serviceTypes: GmbServiceType[];
  moreHoursTypes: GmbMoreHoursType[];
}

export interface GmbLocationKey {
  placeId: string;
  requestId: string;
}

export interface GmbLatlng {
  latitude: number;
  longitude: number;
}

export interface GmbOpenInfo {
  status: string;
  canReopen: boolean;
}

export interface GmbLocationState {
  canUpdate: boolean;
  canDelete: boolean;
  isVerified: boolean;
  isPublished: boolean;
  canModifyServiceList: boolean;
  isGoogleUpdated?: boolean;
}

export interface GmbMetadata {
  mapsUrl: string;
  newReviewUrl: string;
}

export interface GmbAddress {
  regionCode: string;
  languageCode: string;
  postalCode: string;
  administrativeArea: string;
  locality: string;
  sublocality: string;
  addressLines: string[];
}

export interface GmbProfile {
  description: string;
}

export interface GmbPeriod {
  openDay: string;
  openTime: string;
  closeDay: string;
  closeTime: string;
}

export interface GmbRegularHours {
  periods: GmbPeriod[];
}

export interface GmbLabel {
  displayName: string;
}

export interface GmbLabel2 {
  displayName: string;
}

export interface GmbSection {
  sectionId: string;
  labels: GmbLabel2[];
}

export interface GmbPriceList {
  priceListId: string;
  labels: GmbLabel[];
  sections: GmbSection[];
}

export interface GmbLocation {
  name?: string;
  storeCode?: string;
  locationName?: string;
  primaryPhone?: string;
  primaryCategory?: GmbPrimaryCategory;
  websiteUrl?: string;
  locationKey?: GmbLocationKey;
  latlng?: GmbLatlng;
  openInfo?: GmbOpenInfo;
  locationState?: GmbLocationState;
  metadata?: GmbMetadata;
  languageCode?: string;
  address?: GmbAddress;
  profile?: GmbProfile;
  regularHours?: GmbRegularHours;
  priceLists?: GmbPriceList[];
  title?: string;
  storefrontAddress?: any;
  categories?: any;
  phoneNumbers?: any;
}
